import OutroScreen from "./OutroScreen";
import withResponsiveUtils from "../../utils/ResponsiveUtils";

export default withResponsiveUtils(OutroScreen);
